<template>
  <div class="Crisis_Memcon_view">
    <el-descriptions class="margin-top" :column="4"  border>
      <el-descriptions-item>
        <template slot="label">
          姓名
        </template>
        {{ data.realName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          学号
        </template>
        {{ data.userID }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          心理辅导员
        </template>
        {{ data.teachID }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          谈话时间
        </template>
        {{ data.talkTime }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          谈话地点
        </template>
        {{ data.talkAddress }}
      </el-descriptions-item>
      <el-descriptions-item span="2">
        <template slot="label">
          初评危机状态
        </template>
        <span v-if="data.FirstCrisis == '1'" style="color: #C20D04;">红色预警</span>
        <span v-else-if="data.FirstCrisis == '2'" style="color: rgba(252, 111, 68, 1);">橙色预警</span>
        <span v-else-if="data.FirstCrisis == '3'" style="color: rgba(255, 196, 0, 1);">黄色预警</span>
        <span v-else-if="data.FirstCrisis == '4'" style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="data.FirstCrisis == '5'" style="color: #3AC282;">绿色预警</span>
        <span v-else-if="data.FirstCrisis == '6'">绿色预警</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          心理中心建议
        </template>
        <div v-for="item in data.psychCentralSuggests" :key="item">
          <span v-if="item == '1'">精神专科就医</span>
          <span v-if="item == '2'">心理咨询</span>
          <span v-if="item == '3'">心理危机干预</span>
          <span v-if="item == '4'">保密突破联系监护人</span>
          <span v-if="item == '5'">报警急救</span>
          <span v-if="item == '6'">严密守护</span>
          <span v-if="item == '7'">密切陪护</span>
          <span v-if="item == '8'">重点关注</span>
          <span v-if="item == '9'">适当关注</span>
          <span v-if="item == '10'">正常交流</span>
          <span v-if="item == '11'">其他</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          严重情况突出表现
        </template>
        <span v-if="data.suicidalFlg == '1'">有</span>
        <span v-else-if="data.suicidalFlg == '2'">无</span>
        <span v-else-if="data.suicidalFlg == '3'">待确定</span>
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label">
          严重情况突出表现
        </template>
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label">
          关于伤害的情况
        </template>
        <!-- {{ data.suicidalFlg }} -->
        <span v-if="data.suicidalFlg == '1'">有</span>
        <span v-else-if="data.suicidalFlg == '2'">无</span>
        <span v-else-if="data.suicidalFlg == '3'">待确定</span>
      </el-descriptions-item>
      <el-descriptions-item span="2">
        <template slot="label">
          发生时间
        </template>
        {{ data.suicidalDate }}
      </el-descriptions-item>
      <el-descriptions-item span="4">
        <template slot="label">
          发生情况
        </template>
        {{ data.suicidalDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          疑似重性精神障碍
        </template>
        <span v-if="data.psychosesFlg == '1'">有</span>
        <span v-else-if="data.psychosesFlg == '2'">无</span>
        <span v-else-if="data.psychosesFlg == '3'">待确定</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">疑似出现</template>
        <div v-for="item in data.suspectedAppears" :key="item">
          <span v-if="item == '1'">感知觉障碍</span>
          <span v-if="item == '2'">思维障碍</span>
          <span v-if="item == '3'">注意障碍</span>
          <span v-if="item == '4'">记忆障碍</span>
          <span v-if="item == '5'">定向力障碍</span>
          <span v-if="item == '6'">情感障碍</span>
          <span v-if="item == '7'">意志障碍</span>
          <span v-if="item == '8'">动作与行为障碍</span>
          <span v-if="item == '9'">意识障碍</span>
          <span v-if="item == '10'">自知力缺失</span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item span="2">
        <template slot="label">发生时间</template>
        {{ data.psychosesDate }}
      </el-descriptions-item>
      <el-descriptions-item span="4"> 
        <template slot="label">发生情况</template>
        {{ data.psychosesDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">谈话时间</template>
        {{ data.appearDate }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">谈话地点</template>
        {{ data.appearAddress }}
      </el-descriptions-item>
      <el-descriptions-item span="2">
        <template slot="label">主要情况</template>
        {{ data.appearDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">上报领导情况</template>
        <span v-if="data.reportLeaderFlg == '1'">是</span>
        <span v-else-if="data.reportLeaderFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item span="3">
        <template slot="label">详情</template>
        {{ data.reportLeaderDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">与家长沟通情况</template>
        <span v-if="data.parentFlg == '1'">是</span>
        <span v-else-if="data.parentFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item span="3">
        <template slot="label">详情</template>
        {{ data.parentDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">就医情况</template>
        <span v-if="data.hospitalFlg == '1'">是</span>
        <span v-else-if="data.hospitalFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">医院名称</template>
        {{ data.hospitalName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">医院诊断为</template>
        {{ data.hospitalDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">服药情况</template>
        {{ data.medicineFlg }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">是否在心理中心咨询</template>
        <span v-if="data.counsultFlg == '1'">是</span>
        <span v-else-if="data.counsultFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">咨询开始时间</template>
        {{ data.counsultBegin }}
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label">
          咨询开始时间
        </template>
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label">
          咨询次数
        </template>
        {{ data.counsultTimes }}
      </el-descriptions-item>
      <el-descriptions-item span="2">
        <template slot="label">是否推荐去心理中心</template>
        <span v-if="data.recommendCounsultFlg == '1'">是</span>
        <span v-else-if="data.recommendCounsultFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item span="2">
        <template slot="label">后续实际是否去了</template>
        <span v-if="data.realityCounsultFlg == '1'">是</span>
        <span v-else-if="data.realityCounsultFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item span="4">
        <template slot="label">心理联络员配合工作情况</template>
        {{ data.contactWorkDetail }}
      </el-descriptions-item>
      <el-descriptions-item span="4">
        <template slot="label">心理委员配合工作情况</template>
        {{ data.committWorkDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">对接部门</template>
        {{ data.contactDeptName }}
      </el-descriptions-item>
      <el-descriptions-item span="3">
        <template slot="label">对接情况</template>
        {{ data.otherTeacherDetail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">多方会商</template>
        <span v-if="data.multiPartyFlg == '1'">是</span>
        <span v-else-if="data.multiPartyFlg == '2'">否</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          上次谈话后危机状态
        </template>
        <span v-if="data.talkCrisisGrade == '1'"       style="color: red;">红色预警</span>
        <span v-else-if="data.talkCrisisGrade == '2'"  style="color: rgba(252, 111, 68, 1);">橙色预警</span>
        <span v-else-if="data.talkCrisisGrade == '3'"  style="color: rgba(255, 196, 0, 1);">黄色预警</span>
        <span v-else-if="data.talkCrisisGrade == '4'"  style="color: #409EFF;">蓝色预警</span>
        <span v-else-if="data.talkCrisisGrade == '5'"  style="color: #00f670;">绿色预警</span>
        <span v-else-if="data.talkCrisisGrade == '6'" >绿色预警</span>
      </el-descriptions-item>
    </el-descriptions>
    <div style="padding-bottom:20px;">
      <h2 style="margin-left:20px;padding-top:20px;padding-bottom:20px;">调整后危机状态</h2>
      <el-radio-group v-model="ruleForm.adjustCrisisGrade" style="margin-left: 20px;">
        <el-radio label="1">红色预警</el-radio>
        <el-radio label="2">橙色预警</el-radio>
        <el-radio label="3">黄色预警</el-radio>
        <el-radio label="4">蓝色预警</el-radio>
        <el-radio label="5">绿色预警</el-radio>
      </el-radio-group>
    </div>
    <el-button type="primary" @click="apply()" style="margin-left: 20px;">确定申请</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      TalkNo: '',
      RoleID: '',
      KeyNo: '',
      TalkCrisisGrade: '',
      data: [],
      ruleForm: {
        adjustCrisisGrade: '',
      } 
    }
  },
  methods: {
    apply() {
      if (this.ruleForm.adjustCrisisGrade) {
        this.$Http_Post('/DistressPrediction/AdjustStatus', { TalkNo: this.TalkNo, AdjustCrisisGrade: this.ruleForm.adjustCrisisGrade, KeyNo: this.KeyNo, TalkCrisisGrade: this.TalkCrisisGrade }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            if (this.RoleID == "1071") {
              this.$router.push({path: '/Crisis/Crisis_Intervent_Committee'});
            } else {
              this.$router.push({path: '/Crisis/Crisis_Intervent'});
            }
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      } else {
        this.Global.request_failure("请选择调整后危机状态！");
      }
    }
  },
  mounted() {
    this.TalkNo = [this.$route.query.TalkNo][0];
    this.RoleID = sessionStorage.getItem('RoleID');
    this.KeyNo  = [this.$route.query.KeyNo][0];
    this.TalkCrisisGrade = [this.$route.query.TalkCrisisGrade][0];
    this.$Http_Post('/DistressPrediction/ToExamineData', { TalkNo: this.TalkNo,KeyNo:this.KeyNo}).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
      }
    });
  }
}
</script>
<style>
.Crisis_Memcon_view{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Crisis_Memcon_view .el-descriptions{width: 98%;margin-left: 1%;padding-top: 20px;}
</style>